export const SCHEDULE_FIELDS = [
  "Doug Wright",
  "Sherwood D2",
  "Sherwood D3",
  "Sherwood D4",
] as const;

export type ScheduleField = (typeof SCHEDULE_FIELDS)[number];

export const SCHEDULE_TIME_SLOTS = [
  { value: "early", label: "6:45 PM", name: "Early" },
  { value: "late", label: "8:45 PM", name: "Late" },
] as const;

export type ScheduleTimeSlot = (typeof SCHEDULE_TIME_SLOTS)[number]["value"];

export const SCHEDULE_TIME_SLOT_VALUES = SCHEDULE_TIME_SLOTS.map(
  ({ value }) => value,
);

export const SCHEDULE_STATUSES = ["scheduled", "active", "completed"] as const;

export type ScheduleStatus = (typeof SCHEDULE_STATUSES)[number];

export const SPECIAL_BEER_DUTY_OPTIONS = [
  {
    kind: "judge_night",
    label: "Judge Night",
    editorLabel: "Judge Night · nobody brings beer",
  },
  {
    kind: "shrapnel",
    label: "Shrapnel",
    editorLabel: "Shrapnel",
  },
] as const;

export type SpecialBeerDutyKind =
  (typeof SPECIAL_BEER_DUTY_OPTIONS)[number]["kind"];

export type SpecialBeerDuty = {
  [Kind in SpecialBeerDutyKind]: { kind: Kind };
}[SpecialBeerDutyKind];

export type BeerDutyJudgeNight = Extract<
  SpecialBeerDuty,
  { kind: "judge_night" }
>;
export type BeerDutyShrapnel = Extract<SpecialBeerDuty, { kind: "shrapnel" }>;

export interface BeerDutyPlayer {
  kind: "player";
  playerId: string;
  nameSnapshot: string;
}

export type BeerDuty = SpecialBeerDuty | BeerDutyPlayer;

export const DEFAULT_SPECIAL_BEER_DUTY_KIND: SpecialBeerDutyKind =
  SPECIAL_BEER_DUTY_OPTIONS[0].kind;

export function isScheduleField(value: unknown): value is ScheduleField {
  return SCHEDULE_FIELDS.some((field) => field === value);
}

export function isScheduleTimeSlot(value: unknown): value is ScheduleTimeSlot {
  return SCHEDULE_TIME_SLOTS.some(({ value: slot }) => slot === value);
}

export function isScheduleStatus(value: unknown): value is ScheduleStatus {
  return SCHEDULE_STATUSES.some((status) => status === value);
}

export function isSpecialBeerDutyKind(
  value: unknown,
): value is SpecialBeerDutyKind {
  return SPECIAL_BEER_DUTY_OPTIONS.some(({ kind }) => kind === value);
}

export function createSpecialBeerDuty(
  kind: SpecialBeerDutyKind,
): SpecialBeerDuty {
  return { kind };
}

export function specialBeerDutyLabel(kind: SpecialBeerDutyKind): string {
  return (
    SPECIAL_BEER_DUTY_OPTIONS.find((option) => option.kind === kind)?.label ??
    kind
  );
}
